import * as React from 'react';

import TasksSvg from '../assets/tasks.svg';

import styles from './help-graphic-tasks.module.css';

export class HelpGraphicTasks extends React.PureComponent<Record<any, any>> {
    render() {
        return (
            <div className={styles.tasks}>
                <TasksSvg />
            </div>
        );
    }
}
